module.exports = __webpack_public_path__ + "static/img/MCS-LH.5cba45ab.jpg";